// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__l_ej9","anchorLink":"Header_anchorLink__Tpo9A"};